// assets
import { IdcardOutlined, CopyOutlined, UsergroupDeleteOutlined, BuildOutlined } from '@ant-design/icons';

const icons = {
  IdcardOutlined,
  CopyOutlined,
  UsergroupDeleteOutlined,
  BuildOutlined
};

const menuItems = {
  id: 'common-management',
  title: 'Thông tin chung',
  type: 'group',
  roles: ['admin'],
  children: [
    {
      id: 'exam-skill',
      title: 'Kỹ năng',
      type: 'item',
      url: '/exam-skill',
      icon: icons.UsergroupDeleteOutlined,
      target: false,
      visible: true,
      roles: ['admin']
    },
    {
      id: 'level',
      title: 'Cấp độ',
      type: 'item',
      url: '/level',
      icon: icons.CopyOutlined,
      target: false,
      visible: true,
      roles: ['admin']
    },
    {
      id: 'question-type',
      title: 'Loại câu hỏi',
      type: 'item',
      url: '/question-type',
      icon: icons.IdcardOutlined,
      target: false,
      visible: true,
      roles: ['admin']
    },
    {
      id: 'school',
      title: 'Trường',
      type: 'item',
      url: '/school',
      icon: icons.BuildOutlined,
      target: false,
      visible: true,
      roles: ['admin']
    }
  ]
};

export default menuItems;
